var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsString, IsBoolean, IsOptional, ValidateNested, IsDate, IsNumber } from "class-validator";
import { Type } from "class-transformer";
import { willNeverHappen } from "./utils";
export var PatientDataVisualizationCategoryType;
(function (PatientDataVisualizationCategoryType) {
    PatientDataVisualizationCategoryType["CONDITIONS"] = "CONDITIONS";
    PatientDataVisualizationCategoryType["MEDICATIONS"] = "MEDICATIONS";
    PatientDataVisualizationCategoryType["LABS"] = "LABS";
    PatientDataVisualizationCategoryType["ALLERGIES"] = "ALLERGIES";
    PatientDataVisualizationCategoryType["PROCEDURES"] = "PROCEDURES";
    PatientDataVisualizationCategoryType["IMMUNIZATIONS"] = "IMMUNIZATIONS";
    PatientDataVisualizationCategoryType["CLINICAL_VISITS"] = "CLINICAL_VISITS";
    PatientDataVisualizationCategoryType["CLINICAL_NOTES"] = "CLINICAL_NOTES";
})(PatientDataVisualizationCategoryType || (PatientDataVisualizationCategoryType = {}));
export var PatientDataVisualizationPdfStatus;
(function (PatientDataVisualizationPdfStatus) {
    PatientDataVisualizationPdfStatus["PENDING"] = "PENDING";
    PatientDataVisualizationPdfStatus["GENERATING"] = "GENERATING";
    PatientDataVisualizationPdfStatus["GENERATED"] = "GENERATED";
    PatientDataVisualizationPdfStatus["UPLOADING"] = "UPLOADING";
    PatientDataVisualizationPdfStatus["COMPLETED"] = "COMPLETED";
    PatientDataVisualizationPdfStatus["ERROR"] = "ERROR";
})(PatientDataVisualizationPdfStatus || (PatientDataVisualizationPdfStatus = {}));
export function getCategoryName(category) {
    switch (category) {
        case PatientDataVisualizationCategoryType.CONDITIONS:
            return "Conditions";
        case PatientDataVisualizationCategoryType.MEDICATIONS:
            return "Medications";
        case PatientDataVisualizationCategoryType.LABS:
            return "Labs";
        case PatientDataVisualizationCategoryType.ALLERGIES:
            return "Allergies";
        case PatientDataVisualizationCategoryType.PROCEDURES:
            return "Procedures";
        case PatientDataVisualizationCategoryType.IMMUNIZATIONS:
            return "Immunizations";
        case PatientDataVisualizationCategoryType.CLINICAL_VISITS:
            return "Clinical Visits";
        case PatientDataVisualizationCategoryType.CLINICAL_NOTES:
            return "Clinical Notes";
        default:
            return willNeverHappen(category);
    }
}
export class PatientDataVisualizationBaseRecord {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsDate(),
    Type(() => Date),
    IsOptional()
], PatientDataVisualizationBaseRecord.prototype, "date", void 0);
__decorate([
    IsString()
], PatientDataVisualizationBaseRecord.prototype, "provider", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationBaseRecord.prototype, "name", void 0);
export class PatientDataVisualizationBaseCategory {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationBaseCategory.prototype, "category", void 0);
export class PatientDataVisualizationCarePlanSnippet {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientDataVisualizationCarePlanSnippet.prototype, "date", void 0);
__decorate([
    IsString()
], PatientDataVisualizationCarePlanSnippet.prototype, "text", void 0);
export class PatientDataVisualizationConditionsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationConditionsRecord.prototype, "notes", void 0);
__decorate([
    IsBoolean()
], PatientDataVisualizationConditionsRecord.prototype, "isActive", void 0);
__decorate([
    Type(() => PatientDataVisualizationCarePlanSnippet),
    ValidateNested({ each: true }),
    IsOptional()
], PatientDataVisualizationConditionsRecord.prototype, "latestCarePlans", void 0);
export class PatientDataVisualizationConditions extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.CONDITIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationConditions.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationConditionsRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationConditions.prototype, "records", void 0);
export class PatientDataVisualizationMedicationsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDataVisualizationMedicationsRecord.prototype, "dosage", void 0);
__decorate([
    IsString()
], PatientDataVisualizationMedicationsRecord.prototype, "frequency", void 0);
__decorate([
    IsBoolean()
], PatientDataVisualizationMedicationsRecord.prototype, "isActive", void 0);
export class PatientDataVisualizationMedications extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.MEDICATIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationMedications.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationMedicationsRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationMedications.prototype, "records", void 0);
export class PatientDataVisualizationLabsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDataVisualizationLabsRecord.prototype, "value", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationLabsRecord.prototype, "referenceRange", void 0);
__decorate([
    IsBoolean()
], PatientDataVisualizationLabsRecord.prototype, "isOutOfRange", void 0);
__decorate([
    IsBoolean()
], PatientDataVisualizationLabsRecord.prototype, "referenceRangeIsApplicable", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationLabsRecord.prototype, "notes", void 0);
export class PatientDataVisualizationLabsSection {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDataVisualizationLabsSection.prototype, "section", void 0);
__decorate([
    Type(() => PatientDataVisualizationLabsRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationLabsSection.prototype, "records", void 0);
export class PatientDataVisualizationLabs extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.LABS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationLabs.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationLabsSection),
    ValidateNested({ each: true })
], PatientDataVisualizationLabs.prototype, "sections", void 0);
export class PatientDataVisualizationAllergiesRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationAllergiesRecord.prototype, "description", void 0);
export class PatientDataVisualizationAllergies extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.ALLERGIES;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationAllergies.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationAllergiesRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationAllergies.prototype, "records", void 0);
export class PatientDataVisualizationProceduresRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationProceduresRecord.prototype, "description", void 0);
export class PatientDataVisualizationProcedures extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.PROCEDURES;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationProcedures.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationProceduresRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationProcedures.prototype, "records", void 0);
export class PatientDataVisualizationImmunizationsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationImmunizationsRecord.prototype, "fullName", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationImmunizationsRecord.prototype, "description", void 0);
export class PatientDataVisualizationImmunizations extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.IMMUNIZATIONS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationImmunizations.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationImmunizationsRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationImmunizations.prototype, "records", void 0);
export class PatientDataVisualizationClinicalVisitsRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationClinicalVisitsRecord.prototype, "description", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], PatientDataVisualizationClinicalVisitsRecord.prototype, "diagnoses", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], PatientDataVisualizationClinicalVisitsRecord.prototype, "careTeamMemberNames", void 0);
export class PatientDataVisualizationClinicalVisits extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.CLINICAL_VISITS;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationClinicalVisits.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationClinicalVisitsRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationClinicalVisits.prototype, "records", void 0);
export class PatientDataVisualizationClinicalNotesRecord extends PatientDataVisualizationBaseRecord {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDataVisualizationClinicalNotesRecord.prototype, "practitioner", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationClinicalNotesRecord.prototype, "location", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDataVisualizationClinicalNotesRecord.prototype, "encounterDiagnosis", void 0);
__decorate([
    IsString()
], PatientDataVisualizationClinicalNotesRecord.prototype, "noteText", void 0);
export class PatientDataVisualizationClinicalNotes extends PatientDataVisualizationBaseCategory {
    constructor(fields) {
        super(fields);
        this.category = PatientDataVisualizationCategoryType.CLINICAL_NOTES;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationClinicalNotes.prototype, "category", void 0);
__decorate([
    Type(() => PatientDataVisualizationClinicalNotesRecord),
    ValidateNested({ each: true })
], PatientDataVisualizationClinicalNotes.prototype, "records", void 0);
export class PatientDataVisualizationProviderCareTeamRow {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], PatientDataVisualizationProviderCareTeamRow.prototype, "provider", void 0);
__decorate([
    IsString({ each: true })
], PatientDataVisualizationProviderCareTeamRow.prototype, "memberNames", void 0);
export class PatientDataVisualizationSnapshotCategoryDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationSnapshotCategoryDto.prototype, "category", void 0);
__decorate([
    IsString({ each: true })
], PatientDataVisualizationSnapshotCategoryDto.prototype, "records", void 0);
export class PatientDataVisualizationDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate()
], PatientDataVisualizationDto.prototype, "createdAt", void 0);
__decorate([
    IsString()
], PatientDataVisualizationDto.prototype, "name", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientDataVisualizationDto.prototype, "dob", void 0);
__decorate([
    IsString({ each: true })
], PatientDataVisualizationDto.prototype, "providers", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientDataVisualizationDto.prototype, "providersSince", void 0);
__decorate([
    Type(() => PatientDataVisualizationProviderCareTeamRow),
    ValidateNested({ each: true }),
    IsOptional()
], PatientDataVisualizationDto.prototype, "providerCareTeams", void 0);
__decorate([
    Type(() => PatientDataVisualizationBaseCategory, {
        discriminator: {
            property: "category",
            subTypes: [
                { value: PatientDataVisualizationConditions, name: PatientDataVisualizationCategoryType.CONDITIONS },
                { value: PatientDataVisualizationMedications, name: PatientDataVisualizationCategoryType.MEDICATIONS },
                { value: PatientDataVisualizationLabs, name: PatientDataVisualizationCategoryType.LABS },
                { value: PatientDataVisualizationAllergies, name: PatientDataVisualizationCategoryType.ALLERGIES },
                { value: PatientDataVisualizationProcedures, name: PatientDataVisualizationCategoryType.PROCEDURES },
                { value: PatientDataVisualizationImmunizations, name: PatientDataVisualizationCategoryType.IMMUNIZATIONS },
                { value: PatientDataVisualizationClinicalVisits, name: PatientDataVisualizationCategoryType.CLINICAL_VISITS },
                { value: PatientDataVisualizationClinicalNotes, name: PatientDataVisualizationCategoryType.CLINICAL_NOTES },
            ],
        },
    }),
    ValidateNested({ each: true })
], PatientDataVisualizationDto.prototype, "categories", void 0);
export class PatientDataVisualizationLiteCategoryDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(PatientDataVisualizationCategoryType)
], PatientDataVisualizationLiteCategoryDto.prototype, "category", void 0);
__decorate([
    IsNumber()
], PatientDataVisualizationLiteCategoryDto.prototype, "total", void 0);
export class PatientDataVisualizationLiteDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate()
], PatientDataVisualizationLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsString()
], PatientDataVisualizationLiteDto.prototype, "name", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], PatientDataVisualizationLiteDto.prototype, "dob", void 0);
__decorate([
    IsString({ each: true })
], PatientDataVisualizationLiteDto.prototype, "providers", void 0);
__decorate([
    Type(() => PatientDataVisualizationLiteCategoryDto),
    ValidateNested({ each: true })
], PatientDataVisualizationLiteDto.prototype, "categories", void 0);
export const mockPatientDataVisualizationLiteDto = new PatientDataVisualizationLiteDto({
    createdAt: new Date(),
    name: "Camila Maria Lopez",
    dob: new Date("1964-03-21"),
    providers: ["Mountain View General Hosptial", "Oxbridge Health", "Acme Health"],
    categories: [
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.CONDITIONS,
            total: 7,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.MEDICATIONS,
            total: 5,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.LABS,
            total: 130,
        }),
        new PatientDataVisualizationLiteCategoryDto({
            category: PatientDataVisualizationCategoryType.ALLERGIES,
            total: 27,
        }),
    ],
});
